import mergeStyleProps from '@lib/utils/styles/mergeStyleProps';
import React from 'react';
import { useTheme } from 'styled-components';
import type { IconButtonProps } from '../../../icon-button';
import IconButton from '../../../icon-button';
import { AvatarActionSC } from './avatar-action.styled';

interface AvatarActionProps extends Omit<IconButtonProps, 'size' | 'label' | 'shape'> {}

const AvatarAction: React.FunctionComponent<AvatarActionProps> = ({ style, ...rest }) => {
  const theme = useTheme();

  return (
    <AvatarActionSC>
      <IconButton
        style={mergeStyleProps({ boxShadow: theme.shadows.low, borderRadius: 16 }, style)}
        {...rest}
        size="small"
        shape="round"
      />
    </AvatarActionSC>
  );
};

export default AvatarAction;
